export * from './CookieConsentScript.component';
